import { Injectable } from '@angular/core';
import  {ContactData} from "../interfaces/contactData";
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class ContactsService {
  constructor(private http: HttpClient) { }
  getContacts() {
    return this.http.get<any>(`assets/contact.json`)
    .toPromise()
    .then(res => <ContactData[]>res.data)
    .then(data => { return data; });
  }
}
